import React from 'react';
import { Link } from 'react-router-dom'; // For navigation if using react-router

const ErrorPage = () => {
  return (
    <div style={styles.container}>
      <div style={styles.content}>
        <h1 style={styles.header}>404</h1>
        <p style={styles.message}>Page Not Found</p>
        <p style={styles.description}>
          Oops! The page you are looking for does not exist.
        </p>
        <Link to="/home" style={styles.link}>Go Back to Home</Link>
      </div>
    </div>
  );
};

// Inline styles for the ErrorPage component
const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100vh',
    backgroundColor: 'rgb(216, 208, 199',
    padding: '0 20px',
    fontFamily: "'Roboto', sans-serif",
  },
  content: {
    textAlign: 'center',
    backgroundColor: '#ffffff',
    padding: '40px',
    borderRadius: '8px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
    maxWidth: '600px',
    width: '100%',
  },
  header: {
    fontSize: '8rem',
    fontWeight: 'bold',
    color: '#dc3545',
    margin: '0',
    lineHeight: '1',
  },
  message: {
    fontSize: '1.5rem',
    color: '#343a40',
    margin: '10px 0',
  },
  description: {
    fontSize: '1rem',
    color: '#6c757d',
    marginBottom: '20px',
  },
  link: {
    fontSize: '1rem',
    color: '#007bff',
    textDecoration: 'none',
    fontWeight: '500',
    borderRadius: '4px',
    padding: '10px 20px',
    // border: '1px solid #007bff',
    transition: 'background-color 0.3s, color 0.3s',
  },
  linkHover: {
    backgroundColor: '#007bff',
    color: '#ffffff',
  }
};

export default ErrorPage;
